export const SELF_SIGNUP = '/signup'
export const AWS_SELF_SIGNUP = '/aws-signup'

export const SWITCHAGENT = '/switch/agent'
export const CHOOSEAGENT = '/choose/agent'

// START dashboard routes
export const USAGETRENDS = '/dashboard/usagetrends'
export const USAGETRENDS_USERSESSIONS = '/dashboard/usagetrends/usersessions'
export const USAGETRENDS_USERSESSIONS_EMAILORUSERNAME =
  '/dashboard/learner-profile/:userIdOrEmail'
export const LEARNER_CONVERSATIONS =
  '/dashboard/conversations/:userIdOrEmail/:sessionId'
// END dashboard routes

// START Knowledge routes
export const KNOWLEDGE = '/knowledge'
export const KNOWLEDGE_UPLOAD_DOCUMENTS = '/knowledge/upload-documents'
export const KNOWLEDGE_GENERATE_QUESTIONS = '/knowledge/generate-questions'
export const KNOWLEDGE_GENERATE_ANSWERS = '/knowledge/generate-answers'
export const KNOWLEDGE_KEYPHRASES = '/knowledge/key-phrases'
export const KNOWLEDGE_ALL = '/knowledge/all'
export const KNOWLEDGE_ARCHIVED = '/knowledge/archived'
export const KNOWLEDGE_UPLOAD_URL_DOCUMENTS = '/knowledge/upload-url-documents'
export const KNOWLEDGE_KNOWLEDGE_CREATE_FROM_SCRATCH =
  '/knowledge/knowledge-create-from-scratch'
export const KNOWLEDGE_SETUP = '/knowledge/setup/:id'
export const KNOWLEDGE_SETUP_CONTEXTUALISED_CHAT = '/knowledge/setup/chat'
export const KNOWLEDGE_IMPORT_LMS_CONTENT = '/knowledge/import-lms-content'
export const KNOWLEDGE_CONVERSATION_FLOW = '/knowledge/conversation-flow'
// END Knowledge routes

export const FORMS = '/forms'
export const CHAT_CUSTOMISATION = '/chat-customisation'
export const USER_MANAGEMENT = '/users'
export const NOTIFICATION = '/notification'
export const DOCUMENTDETAILBYID = '/uploaded-documents/:documentId'
export const QUIZZDETAILSBYID = '/quiz/:quizId/type/:quizType'
export const QUIZZALLSUBMISSIONBYID = '/quiz/:quizId/all/submissions'
export const QUIZZALLREVIEWREQUESTSBYID = '/quiz/:quizId/all/review-request'
export const QUIZZSUBMISSIONBYSUBMISSIONID =
  '/quiz/:quizId/all/submissions/:submissionId/:email'
export const QUIZZQUESTIONBREAKDOWNBYID = '/quiz/question/breakdown/:quizId'
export const QUIZDETAILBYUSER = '/quiz/:quizId/user/:userId'
export const USER_REGISTRATION = '/organisation/users/registration/:token'

export const MATCHED_UNMATCHED_QUESTIONS =
  '/dashboard/matched-unmatched-questions'
export const REPORTS_QUIZZES = '/dashboard/reports-quizzes'
export const DISCUSSION = '/dashboard/discussion'

export const OVERVIEW = '/dashboard/overview'
export const USERGROUP_CLASS_ACCESS = '/usergroup/class-access/:type/:id'
export const DOCUMENT_SECTIONS = '/document-sections'

export const MANAGEKNOWLEDGEGROUP = '/manage/groups'
export const SUPPORT = '/support'
export const SUPPORT_SUB_PATH = '/support/:path'
export const UPDATE_CLASS = '/update-class/:classId'
export const UPDATE_LEARNER_GROUP = '/update-learner-group/:groupId'
export const UPLOAD_LIST_OF_USERS = '/upload-list-of-users'

export const GET_QUIZ_BYID = '/quizzes/edit/:quizId'
export const EXERCISES = '/quizzes'
export const EXERCISES_ARCHIVE = '/quizzes/archived'
export const EXERCISES_REVIEW = '/quizzes/review'

export const EDIT_QUESTION_BANK = '/quizzes/bank/edit/:questionId'
export const EDIT_QUESTIONS_BANK = '/quizzes/bank/questions/edit'
export const CREATE_QUESTION_BANK = '/quizzes/bank/create'
export const IMPORT_QUIZ = '/import-quiz'
export const CREATE_QUIZ_FROM_QUESTION_ID = '/quiz-questions/:questionId'
export const IMPORTQUESTIONBANK = '/import-questions-bank'
export const IMPORTQUESTIONBANK_PREVIEW =
  '/import-questions-bank/preview/:docId'
export const IMPORTQUESTIONBANK_PREVIEWS_TAG =
  '/import-questions-bank/preview-tags'
export const IMPORTQUESTIONBANK_PREVIEWS_QUESTIONS =
  '/import-questions-bank/questions-review'

export const REPORTS_QUIZZES_ALL_SUBMISSIONS =
  '/dashboard/report-quizzes-all-submissions'
export const BUILD_MULTI_DOCUMENTS_SECTION =
  '/build/:step/multi-documents-section'
export const BUILD_SUMMARISE_MULTI_DOCUMENTS_SECTION =
  '/build/:step/:subStep/multi-documents-section'
export const BUILD_SUMMARISE_DOCUMENT = '/build/:step/document-summary'
export const LEARNING_OUTCOMES_UPDATE = '/update-learning-outcomes'

export const GENERATE_KNOWLEDGE = '/build/:step/generate-knowledge/:questionId'
export const GENERATE_QNA = '/build/:step/generate-knowledge'
export const BUILD_FINAL = '/build/final'
export const EXPORT_QUESTION_BANK = '/export-question-bank'
export const ONBOARD = '/'

export const CREATE_SMART_QUIZ = '/toolkit/create-quiz/smart'
export const SMART_QUIZ_SELECT_PAGES = '/toolkit/create-quiz/select-pages'
export const SMART_QUIZ_PROCESS_DOCUMENTS =
  '/toolkit/create-quiz/process-documents'
export const TOOLKIT_SMART_QUIZ_SUMMARISE_DOCUMENTS =
  '/toolkit/create-quiz/summarise-documents'
export const REVIEW_QUIZ_QUESTIONS = '/toolkit/create-quiz/review-quiz'
export const GUIDED_QUIZESS_IMPORT = '/toolkit/create-quiz/guided/import-quiz'

export const TOOLKIT_GENERATE_QNA_UPLOAD_DOC =
  '/toolkit/generate-qna/upload-document'
export const TOOLKIT_GENERATE_QNA_SELECT_PAGES =
  '/toolkit/generate-qna/select-pages'
export const TOOLKIT_GENERATE_QNA_PROCESS_DOCUMENTS =
  '/toolkit/generate-qna/process-documents'
export const TOOLKIT_GENERATE_QNA_SUMMARISE_DOCUMENTS =
  '/toolkit/generate-qna/summarise-documents'
export const TOOLKIT_GENERATE_QNA = '/toolkit/generate-qna'
export const TOOLKIT_GENERATE_QNA_FINAL = '/toolkit/generate-qna/final'

export const TOOLKIT_SUMMARISE_DOCUMENTS = '/toolkit/summarise-documents'
export const TOOLKIT_SUMMARISE_DOCUMENTS_SELECT_PAGES =
  '/toolkit/summarise-documents/select-pages'
export const TOOLKIT_SUMMARISE_DOCUMENTS_SINGLE_MULTIPLE =
  '/toolkit/summarise-documents/summarise'
export const TOOLKIT_SUMMARISE_DOCUMENTS_FINAL =
  '/toolkit/summarise-documents/final'

export const TOOLKIT_GENERATE_LEARNING_OUTCOMES =
  '/toolkit/generate-learning-outcomes'
export const TOOLKIT_GENERATE_LEARNING_OUTCOMES_SELECT_PAGES =
  '/toolkit/generate-learning-outcomes/select-pages'
export const TOOLKIT_GENERATE_LEARNING_OUTCOMES_PROCESS_DOCS =
  '/toolkit/generate-learning-outcomes/process-documents'
export const TOOLKIT_GENERATE_LEARNING_OUTCOMES_SUMMARISE_DOCUMENTS =
  '/toolkit/generate-learning-outcomes/summarise-documents'
export const TOOLKIT_GENERATE_LEARNING_OUTCOMES_REVIEW =
  '/toolkit/generate-learning-outcomes/review-outcomes'
export const TOOLKIT_GENERATE_LEARNING_OUTCOMES_FINAL =
  '/toolkit/generate-learning-outcomes/final'
export const TOOLKIT_SETUP_CONTEXTUALISED_CHAT =
  '/toolkit/setup-contextualise-chat'
export const TOOLKIT_SETUP_CONTEXTUALISED_CHAT_WAITING =
  '/toolkit/setup-contextualise-chat/process-documents'
export const TOOLKIT_SETUP_CONTEXTUALISED_CHAT_FINAL =
  '/toolkit/setup-contextualise-chat/follow-up'
export const RESPONSES = '/dashboard/responses'
export const LEARNER_QUESTIONS = '/dashboard/learner-questions'

export const INTEGRATED_SOURCES = '/toolkit/import-from-integrated-sources'

export const CHANGE_ORGANISATION = '/choose/organisation'
// ORGANISATION ROUTES
export const ORGANISATION_DASHBOARD = '/organisation/overview'
export const INTEGRATION_MANAGEMENT = '/organisation/integrations'
export const INTEGRATION_TYPE = '/organisation/integrations/:type'
export const PLAN_MANAGEMENT = '/organisation/plans'
export const ORGANISATION_SUPPORT = '/organisation/support'
